module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "config-form-wrapper row"
  }, [_c('div', {
    staticClass: "config-form col-md-12"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('br'), _c('SmartForm', {
    attrs: {
      "formList": _vm.formList,
      "columns": _vm.columns,
      "buttonList": _vm.buttonList
    },
    model: {
      value: (_vm.formValues),
      callback: function($$v) {
        _vm.formValues = $$v
      },
      expression: "formValues"
    }
  }), _c('br')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63bc8d16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/System/Test.vue
// module id = 1764
// module chunks = 1